
import { NgModule } from '@angular/core';
import { EntityBasedChatDirective } from './directives/entity-based-chat.directive';
@NgModule({
    imports: [
    ],
    declarations: [
      EntityBasedChatDirective
    ],
    exports: [
      EntityBasedChatDirective
    ]
})
export class EntityBasedChatModule { }
